/* =============================================
   Cart Quantity Guard
   File: assets/cart-quantity-guard.js

   Strategy: don't touch the submit event at all.
   Dawn's product-form.js owns that entirely.
   We only manage button disabled state based
   on what's in the cart.

   Button structure (from product-form.liquid):
   <button name="add">
     <span>SVG icon</span>      ← spans[0], skip
     <span>Add to cart</span>   ← spans[last], update this
     <loading-spinner>
   </button>
   ============================================= */

(function () {

  /* ── Fetch cart ── */
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  /* ── Debounce helper ── */
  function debounce(fn, wait) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  /* ── Get the text span (last span) from the button ── */
  function getTextSpan(btn) {
    const spans = btn.querySelectorAll(':scope > span');
    return spans.length ? spans[spans.length - 1] : null;
  }

  /* ── Update all add-to-cart button states ── */
  async function updateButtonStates() {
    const cart = await getCart();
    const cartVariantIds = new Set(cart.items.map((i) => i.variant_id));

    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      const variantId = parseInt(variantInput.value, 10);
      const btn = form.querySelector('[name="add"]');
      if (!btn) return;

      const textSpan = getTextSpan(btn);

      if (cartVariantIds.has(variantId)) {
        /* Save original text before overwriting */
        if (!btn.dataset.originalText && textSpan) {
          btn.dataset.originalText = textSpan.textContent.trim();
        }

        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');

        if (textSpan) textSpan.textContent = 'Already in cart';

      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');

        /* Restore original text */
        if (textSpan && btn.dataset.originalText) {
          textSpan.textContent = btn.dataset.originalText;
        }
      }
    });
  }

  /* ── Force quantity to 1 and hide the input widget ── */
  function lockAndHideQuantity() {
    document.querySelectorAll('form[action="/cart/add"] [name="quantity"]').forEach((input) => {
      input.value = 1;
      input.max   = 1;
      input.min   = 1;
      input.addEventListener('change', () => { input.value = 1; });
      input.addEventListener('input',  () => { input.value = 1; });
    });

    document.querySelectorAll('form[action="/cart/add"] .quantity').forEach((wrap) => {
      wrap.style.display = 'none';
    });
  }

  /* ── Watch for variant selection changes ──
     Dawn updates the hidden [name="id"] value when a
     variant is selected — observe that to re-check state. */
  function watchVariantChanges() {
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      const observer = new MutationObserver(debounce(updateButtonStates, 150));
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    });

    document.addEventListener('variant:change', debounce(updateButtonStates, 150));
  }

  /* ── Subscribe to Dawn's pub/sub cart updates (debounced) ── */
  function subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, debounce(updateButtonStates, 300));
  }

  /* ── Init ── */
  function init() {
    updateButtonStates();
    lockAndHideQuantity();
    watchVariantChanges();
    subscribeToCartUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
